<div class="modal">

  <app-icon
    class="modal__close"
    icon="times"
    size="lg"
    title="close"
    (click)="closeDialog()">
  </app-icon>

  <div
    class="modal__contents"
    [style.height]="height + 'px'">

    <iframe
      *ngIf="src"
      [src]="src"
      class="modal__frame">
    </iframe>

  </div>

</div> 